import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} asitrust.com - Premium Domain For Sale</p>
    </footer>
  );
};

export default Footer; 